import { render, staticRenderFns } from "./ClienteHistorial.vue?vue&type=template&id=2506c516"
import script from "./ClienteHistorial.vue?vue&type=script&lang=js"
export * from "./ClienteHistorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports